import React from "react";
import ImageCardList from "../../components/ImageCardList/ImageCardList";
import {
  illustrations,
  illustrations1,
  illustrations2,
} from "../../assets/illustrations/illustrations";

const Illustrations = () => {
  return (
    <div className="main">
      <ImageCardList images={illustrations1} big />
      <ImageCardList images={illustrations2} />
      <ImageCardList images={illustrations} />
    </div>
  );
};

export default Illustrations;
